import { Injectable } from '@angular/core';
import { readFromStorage, writeToStorage } from '../shared/utils/local-storage.utils';

@Injectable({ providedIn: 'root' })
export class ClockService {
    showingClock = true;
    readonly _showClockKey = 'CDP_SHOW_CLOCK';

    constructor() {
        this.checkClockVisibility();
    }

    toggleClock(): void {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.showingClock ? this.hideClock() : this.showClock();
    }

    hideClock(): void {
        this.showingClock = false;
        writeToStorage(this._showClockKey, 'false');
    }

    showClock(): void {
        this.showingClock = true;
        writeToStorage(this._showClockKey, 'true');
    }

    checkClockVisibility(): void {
        this.showingClock = readFromStorage(this._showClockKey) !== 'false';
    }
}
